import Header from "@/components/Header";
import { useParams, useNavigate } from "react-router-dom";
import { RouteWaypointsManager } from "@/components/RouteWaypointsManager";
import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Home, Route } from "lucide-react";

const RouteDetail = () => {
  const { routeId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!routeId) {
    const redirectPath = user ? '/explore' : '/';
    const buttonText = user ? 'Back to Explorer' : 'Return to Home';
    const ButtonIcon = user ? ArrowLeft : Home;

    return (
      <div className="min-h-screen bg-background">
        <Header />
        <main className="container mx-auto px-4 py-8">
          <div className="text-center py-16">
            <Route className="h-16 w-16 mx-auto mb-6 text-muted-foreground" />
            <h1 className="text-2xl font-bold text-foreground mb-4">Route Not Found</h1>
            <p className="text-muted-foreground mb-6">Invalid route ID provided.</p>
            <Button onClick={() => navigate(redirectPath)}>
              <ButtonIcon className="h-4 w-4 mr-2" />
              {buttonText}
            </Button>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-foreground mb-4">Route Detail</h1>
        <p className="text-muted-foreground mb-8">Route ID: {routeId}</p>
        
        <div className="space-y-6">
          <RouteWaypointsManager routeId={routeId} />
          
          {/* Future components can be added here */}
          <div className="text-sm text-muted-foreground">
            Additional route information and map integration coming soon...
          </div>
        </div>
      </main>
    </div>
  );
};

export default RouteDetail;